export const uk = {
    noticeMessageSuccess: {
        one: '{count} группа скопирована в выбранные кампании',
        some: '{count} группы скопированы в выбранные кампании',
        many: '{count} групп скопированы в выбранные кампании',
        none: '{count} групп скопированы в выбранные кампании'
    },
    noticeMessageSuccessOneCampaign: {
        one: '{count} группа скопирована в кампанию № {campaignId}',
        some: '{count} группы скопированы в кампанию № {campaignId}',
        many: '{count} групп скопированы в кампанию № {campaignId}',
        none: '{count} групп скопированы в кампанию № {campaignId}'
    },
    noticeSingleGroupNoticeMessage: 'Группа № {id} скопирована в выбранные кампании',
    noticeSingleGroupSingleCampaignMessage: 'Группа № {id} скопирована в кампанию № {campaignId}'
};
